import React, { useEffect, useRef } from 'react';
import { ExperienceTracker } from '@atlassian/experience-tracker';
import { ExperienceTrackerAdapter, ExperienceTrackerAdapterContext } from '../experience-tracking/adapter';
export var useExperienceTracker = function useExperienceTracker(config) {
  var ref = useRef();
  if (!ref.current) {
    ref.current = ExperienceTrackerAdapter.from(new ExperienceTracker(), config);
  }
  return ref.current;
};
export var NotificationsExperienceTrackerProvider = function NotificationsExperienceTrackerProvider(_ref) {
  var children = _ref.children,
    ufoAttributes = _ref.ufoAttributes;
  var experienceTracker = useExperienceTracker({
    ufoAttributes: ufoAttributes
  });

  // Abort notification experiences if the the window unloads
  useEffect(function () {
    var abortNotificationExperiences = function abortNotificationExperiences() {
      experienceTracker.abortAll({
        reason: 'window-unloading'
      });
    };
    window.addEventListener('beforeunload', abortNotificationExperiences);
    return function () {
      window.removeEventListener('beforeunload', abortNotificationExperiences);
    };
  }, [experienceTracker]);
  return /*#__PURE__*/React.createElement(ExperienceTrackerAdapterContext.Provider, {
    value: experienceTracker
  }, children);
};